module.exports = __webpack_public_path__ + "img/teaser_240x200_ironking.14356081.jpg";